import type { RouteRecordRaw } from 'vue-router'

import { CARRIER_RATES_BETA_FLAG } from '@/features/carrier-rates/beta-features'
import { betaGuard } from '@/router/guards/beta-guard'
import { SETTINGS_CONTRACTS_LIST_ROUTE } from '@/router/routes/settings/carriers-and-prices.routes'

export const EDIT_CARRIER_RATES_ROUTE = 'carrier-rates.edit'

/**
 * note: the path here (contracts/:contractId/rates) is not final and will probably end up changing
 *
 * todo(Jason):
 * - finalise the path
 * - add correct permissions (only admin users should be able to view this page)
 * - translate the page title
 */
export default {
  name: EDIT_CARRIER_RATES_ROUTE,
  path: '/contracts/:contractId/rates',
  component: () => import('@/features/carrier-rates/pages/CarrierRatesPage.vue'),
  props: ({ params }) => ({ contractId: +params.contractId }),
  beforeEnter: betaGuard(CARRIER_RATES_BETA_FLAG, SETTINGS_CONTRACTS_LIST_ROUTE),
  meta: {
    pageTitle: () => 'Carrier rates',
    permissions: ['manage_shipping'],
    backLinkRoute: () => ({
      title: 'All contracts',
      to: { name: SETTINGS_CONTRACTS_LIST_ROUTE },
    }),
  },
} satisfies RouteRecordRaw
